import React, { useState } from "react";
import styles from "./ReviewWidget.module.scss";
import HorizontalInnerNav from "./HorizontalInnerNav";
import classNames from "classnames";
import _ from "lodash";

export const ReviewGrid = React.memo(({children, className, style, autosize}) => {
    return <div className={classNames(styles['review-grid'], {[styles['auto-size']]: autosize}, className)} style={style}>
        {children}
    </div>
});

const Button = ({isActive, activeClassName, children, ...props}) => {
    return <button {...props}>{children}</button>
}

const ReviewWidget = React.memo(({ sections, children: _children = [], style }) => {
    const [currentSection, setCurrentSection] = useState(0);
    const children = _.isArray(_children) ? _children : [_children];

    return <div className={styles.base} style={style}>
        <HorizontalInnerNav expand={true} className={styles['nav']}>
            {sections.map((section, index) => {
                return <Button key={index} isActive={currentSection === index} className={styles['link-no-shadow']}  onClick={() => {setCurrentSection(index)}}>{section}</Button>
            })}
        </HorizontalInnerNav>
        {children[currentSection]}
    </div>
});

export default ReviewWidget;
